import { motion } from 'framer-motion';
import { LockKey, Database, Eye, FileCsv, Cookie, EnvelopeSimple } from '@phosphor-icons/react';

export default function Privacy() {
  const sections = [
    { icon: Database, title: 'Collecte des données', content: 'Nous collectons les informations que vous nous fournissez lors de la réservation : nom, prénom, email, téléphone, adresses de prise en charge et destination, date/heure de course. Les données de paiement sont traitées directement par nos partenaires sécurisés (Stripe) et ne sont pas stockées sur nos serveurs.' },
    { icon: LockKey, title: 'Utilisation des données', content: 'Vos données servent à traiter vos réservations, assurer la prestation de transport, gérer la facturation et le service client, vous envoyer des confirmations et rappels, et améliorer nos services de manière anonyme.' },
    { icon: Eye, title: 'Partage des données', content: 'Nous ne vendons jamais vos données. Elles peuvent être partagées avec : les chauffeurs partenaires (nom, lieux de course), nos prestataires techniques (hébergeur, outil de réservation), ou sur obligation légale.' },
    { icon: FileCsv, title: 'Vos droits (RGPD)', content: 'Vous disposez des droits d’accès, de rectification, d’effacement, de limitation, de portabilité et d’opposition. Pour les exercer, contactez-nous à contact@destidriving.fr. Nous répondons sous un mois.' },
    { icon: Cookie, title: 'Cookies', content: 'Notre site utilise uniquement des cookies essentiels à son bon fonctionnement. Vous pouvez les refuser via les paramètres de votre navigateur, mais certaines fonctionnalités pourraient être altérées.' },
  ];

  return (
    <div className="pt-20" data-testid="privacy-page">
      <section className="py-24 md:py-32">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <p className="text-xs uppercase tracking-[0.2em] text-desti-gold mb-3">Vie privée</p>
            <h1 className="font-heading text-3xl sm:text-4xl text-white mb-2">Politique de confidentialité</h1>
            <p className="text-sm text-desti-text mb-10">Dernière mise à jour : 13 mai 2026</p>
          </motion.div>

          <div className="space-y-8">
            {sections.map((section, idx) => (
              <motion.div
                key={section.title}
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1 }}
                className="bg-desti-surface/50 border border-white/5 p-6 rounded-sm"
              >
                <div className="flex items-center gap-3 mb-3">
                  <section.icon size={24} weight="duotone" className="text-desti-gold" />
                  <h2 className="font-heading text-xl text-white">{section.title}</h2>
                </div>
                <p className="text-desti-text leading-relaxed text-sm">{section.content}</p>
              </motion.div>
            ))}

            <motion.div
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              className="bg-desti-surface/50 border border-white/5 p-6 rounded-sm"
            >
              <div className="flex items-center gap-3 mb-3">
                <EnvelopeSimple size={24} weight="duotone" className="text-desti-gold" />
                <h2 className="font-heading text-xl text-white">Contact délégué à la protection des données</h2>
              </div>
              <p className="text-desti-text leading-relaxed text-sm">
                Pour toute question relative à vos données personnelles : <a href="mailto:contact@destidriving.fr" className="text-desti-gold hover:underline">contact@destidriving.fr</a> ou par courrier au siège social.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}